<template>
    <div>
        <p class="mx-auto text-primary text-center font-weight-bold">ورود به حساب کاربری</p>
        <p class="text-small text-center text-grey-darken-1">با وارد کردن {{ username_type == 'email' ? 'ایمیل' : username_type == 'username' ? 'نام کاربری' : 'موبایل' }} خود وارد سامانه شوید</p>
        <v-form class="mt-5" ref="form" @submit.stop.prevent="$refs.form?.isValid ? $emit('submited', form) : ''">
            <v-text-field
                v-if="username_type == 'email'"
                :rules="$validation(['required', 'email'])"
                ref="email"
                label="* ایمیل"
                v-model="form.email"
                autocomplete="username"
                style="min-width: 300px;"
                :disabled="step"
                append-inner-icon="icon-user"
            ></v-text-field>
            <v-text-field
                v-if="username_type == 'mobile'"
                :rules="$validation('required')"
                ref="mobile"
                label="* موبایل"
                v-model="form.mobile"
                autocomplete="username"
                style="min-width: 300px;"
                :disabled="step"
                append-inner-icon="icon-user"
            ></v-text-field>
            <v-text-field
                v-if="username_type == 'username'"
                :rules="$validation(['required', ($system.systemSettings.username_regex ? 'regex:' + $system.systemSettings.username_regex : false)].filter(Boolean))"
                ref="username"
                label="* نام کاربری"
                v-model="form.username"
                autocomplete="username"
                style="min-width: 300px;"
                :disabled="step"
                append-inner-icon="icon-user"
            ></v-text-field>
            <v-text-field
                v-if="step"
                ref="password"
                :rules="$validation('required')"
                :type="pass1 ? 'password' : 'text'"
                label="* کلمه عبور"
                v-model="form.password"
            >
                <template #append-inner>
                    <v-icon v-if="form.password" class="me-2 cursor-pointer" @click="()=>{pass1 = !pass1}">{{ pass1 ? 'visibility' : 'visibility_off' }}</v-icon>
                    <v-icon>icon-key</v-icon>
                </template>
            </v-text-field>
            <v-btn :loading="loading" class="mx-auto mt-3 mb-3 d-block" width="180" color="primary" type="submit">
                <v-icon class="pe-4" size="18">{{ step ? 'icon-enter' : 'icon-closeticket'}}</v-icon>
                <p class="text-small text-white">{{ step ? 'ورود به سامانه' : 'تایید ' + (username_type == 'email' ? 'ایمیل' : username_type == 'username' ? 'نام کاربری' : 'موبایل') }}</p>
            </v-btn>
            <div class="text-center">
                <v-btn @click="$emit('cancell')" width="180" variant="text" color="secondary" class="text-small mx-auto d-block" v-if="step">تغییر {{ (username_type == 'email' ? 'ایمیل' : username_type == 'username' ? 'نام کاربری' : 'موبایل') }}</v-btn>
                <v-btn @click="$emit('forgotPassword')" width="180" variant="text" color="secondary" class="text-small mx-auto d-block" v-if="step">فراموشی کلمه عبور</v-btn>
                <v-btn @click="$router.push({path: '/signup'})" width="180" variant="text" color="secondary" class="text-small mx-auto d-block" v-if="$system.systemSettings.signup_from_customers_permission">ایجاد حساب کاربری جدید</v-btn>
            </div>
        </v-form>
    </div>
</template>
<script>
export default {
    data () {
        return {
            form: {
                email: null,
                username: null,
                mobile: null,
                password: null,
            },
            index: 0,
            username_type: this.$system.systemSettings.username_type,
            pass1: true,
            intervalDetectAutofill: null,
        }
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        step: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        setInitialValue(value) {
            this.form[this.username_type] = value;
        }
    },
};
</script>
